import { Button, ButtonsGroup, Checkbox, Flex, Modal, ModalProps, Space, Text, useModal } from '@billy/design-system'
import { ReactElement, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { useUpdateOrganizationSettings, useUserOrganization } from '@modules-deprecated/app/organization'

import { StackofInvoices } from '../../../../assets/images'
import { getImageClassName } from '../../../../utils/getClassName'
import { getOrganizationViewUrl } from '../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import * as Styled from './styles'

type AttachmentInformCPAModalProps = ModalProps

export const AttachmentInformCPAModal = ({ id, ...modalProps }: AttachmentInformCPAModalProps): ReactElement => {
  const { t } = useTranslation()
  const { update } = useUpdateOrganizationSettings()
  const { organization } = useUserOrganization()
  const navigate = useNavigate()
  const [shouldNeverShowAgain, setShouldNeverShowAgain] = useState(false)
  const organizationId = organization?.id
  const billsMainUrl = getOrganizationViewUrl(organization?.url, reactRoute.organization.bills.getMainRoute())

  const updateShouldNeverShowAgain = () => {
    setShouldNeverShowAgain(!shouldNeverShowAgain)
  }

  const handleCheckboxChange = () => {
    if (!organizationId || !shouldNeverShowAgain) {
      return
    }
    update({
      key: 'isCpaAttachmentInfoModalDismissed',
      organizationId,
      value: '1',
    })
  }

  const { close } = useModal(id, {
    onClose: () => {
      handleCheckboxChange()
    },
  })

  const handleCloseButtonClick = () => {
    close()
  }

  const handleSeePurchasesClick = () => {
    if (!organization?.url) {
      return
    }
    close()
    navigate(billsMainUrl)
  }

  return (
    <Modal id={id} size="m" autofocusOnInput closable {...modalProps}>
      <Modal.Header title={t('attachments_inform_cpa_modal.title')} />
      <Modal.Body>
        <Flex className={getImageClassName()} flexDirection="column" alignItems="center">
          <StackofInvoices />
        </Flex>
        <Space size="s40" />
        <Styled.TextWrapper>
          <Text>
            <Trans i18nKey="attachments_inform_cpa_modal.description" components={{ strong: <strong /> }} />
          </Text>
        </Styled.TextWrapper>
      </Modal.Body>
      <Modal.Footer>
        <Styled.FooterContentWrapper>
          <Flex justifyContent="space-between" alignItems="center" flexGrow={1}>
            <Checkbox checked={shouldNeverShowAgain} onChange={updateShouldNeverShowAgain}>
              <Text alignment="center">{t('attachments_inform_cpa_modal.dont_show_again')}</Text>
            </Checkbox>
            <ButtonsGroup>
              <Button variant="text" onClick={handleCloseButtonClick}>
                {t('attachments_inform_cpa_modal.keep_uploading')}
              </Button>
              <Button onClick={handleSeePurchasesClick}>{t('attachments_inform_cpa_modal.see_purchases')}</Button>
            </ButtonsGroup>
          </Flex>
        </Styled.FooterContentWrapper>
      </Modal.Footer>
    </Modal>
  )
}
